import { b, a } from './chunk-FUQLNXR2.mjs';
import { jsx } from 'react/jsx-runtime';

var s=l=>jsx("svg",b(a({xmlns:"http://www.w3.org/2000/svg",height:"16",width:"16",viewBox:"0 0 512 512"},l),{children:jsx("path",{d:"M290.5 51.8C283.3 39.5 270.2 32 256 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S25.7 480 40 480H472c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368z",fill:"currentColor"})})),g=s;

export { g as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-4L73W4CZ.mjs.map